import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { HeaderComponent } from './components/shareds/header/header.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { ProductsComponent } from './components/products/products.component';
import { CarritoComponent } from './components/shareds/carrito/carrito.component';

// rutas
import { APP_ROUTING } from './app.routes';
// peticiones http
import { HttpClientModule } from '@angular/common/http';
// servicios

import { SmallshiService } from './services/smallshi.service';
import { LoaingComponent } from './components/shareds/loaing/loaing.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OopsComponent } from "./components/oops/oops.component";
import { ComercioComponent } from './components/comercio/comercio.component';

// maps
import { AgmCoreModule } from '@agm/core';
//import { google } from '@agm/core/services/google-maps-types';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    CategoriesComponent,
    ProductsComponent,
    CarritoComponent,
    LoaingComponent,
    OopsComponent,
    ComercioComponent
    
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB_RvE7EVkuVnnyycDHNQj3-tWsWnqtto0'
      }),
      GooglePlaceModule,
      
    APP_ROUTING,
    NgbModule
  ],
  providers: [
    SmallshiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
